module.exports = __webpack_public_path__ + "static/media/30OIOS8.d1b4d657.jpg";